import React from 'react';
import bg404 from '../images/bg404.webp';
import './section404.css';
import DinosaurGame from './DinosaurGame.js';
const Section404 = () => {
    return (
        <section className='section404' style={{ backgroundImage: `url(${bg404})` }} name='404'>
            <DinosaurGame/>
            <div className='sky'></div>
            <div className='floor'></div>
        </section>
    );
};

export default Section404;